import React from "react";
import { Redirect } from "react-router-dom";
import {
  PageSuspense,
  Roles,
  TaxManagementAlerts,
  SearchResult,
  Businesses,
  BusinessDetail,
  RoleBasedAccess,
} from "../lazyComponents";
import { wrapHeavyFeaturePage } from "../heavyRouteBoundary";
import type { AppRoute } from "../types";

export const rolesAlertsBusinessAuthRoutes: AppRoute[] = [
  {
    path: "/roles",
    main: () => (
      <PageSuspense>
        <Roles />
      </PageSuspense>
    ),
  },
  {
    path: "/alerts",
    main: () => (
      <PageSuspense>
        <TaxManagementAlerts />
      </PageSuspense>
    ),
  },
  {
    path: "/search-result",
    main: () => (
      <PageSuspense>
        <SearchResult />
      </PageSuspense>
    ),
  },
  {
    path: "/businesses",
    main: () => (
      <PageSuspense>
        <Businesses />
      </PageSuspense>
    ),
  },
  {
    path: "/business/:business_id",
    main: wrapHeavyFeaturePage(
      () => (
        <PageSuspense>
          <BusinessDetail />
        </PageSuspense>
      ),
      "BusinessDetail"
    ),
  },
  {
    path: "/Businesses",
    main: () => <Redirect to="/businesses" />,
  },
  {
    path: "/RoleBasedAccess",
    main: () => (
      <PageSuspense>
        <RoleBasedAccess />
      </PageSuspense>
    ),
  },
];
